import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { CompartmentItemFacade } from '../../../compartment/item/compartment-item.facade';
import { SecurityCheckFacade } from './security-check.facade';
import { SecurityCheckContextType } from '../../../../../constants/security-check.constant';

@Injectable({ providedIn: 'root' })
export class CompartmentSecurityCheckGuard {
  constructor(
    private compartmentItemFacade: CompartmentItemFacade,
    private compartmentSecurityCheckFacade: SecurityCheckFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.compartmentSecurityCheckFacade.setContextType(SecurityCheckContextType.Compartment);

    return this.compartmentItemFacade.compartmentId$.pipe(
      switchMap((id: number) => {
        this.compartmentSecurityCheckFacade.setContextId(id);
        return checkStoreState(this.compartmentSecurityCheckFacade, id);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentSecurityCheckFacade);
  }
}
